import { z } from "zod";

z.config({ jitless: true });

export { z };
export type { ZodType } from "zod";
